<div class="row col-12 p-0 m-0 main-page-section ">
  <!-- <div class="p-0">
            <app-side-nav [item]="meetingNav"></app-side-nav>
        </div> -->
  <div class="col-12 p-0 employee-section">
    <!-- <app-header></app-header> -->
    <div class="col-height">

      <div>

        <div class="breadcrumbs-section padding-left">
          <span class="prev-page pr-2 prev" routerLink="/overview">Home</span>
          <img src="../../assets/images/seperator.png">
          <span class="prev-page pr-2 pl-2 prev" routerLink="/vms/individual-invite">Invite</span>
          <img src="../../assets/images/seperator.png">
          <span class="prev-page pr-2 pl-2 prev" routerLink="/vms/individual-invite/invite">Individual-Invite</span>
          <img src="../../assets/images/seperator.png">
          <span class="curr-page pl-2 breadcrumbs-section-font current">Status</span>
        </div>

        <div class="history-layout">

          <div class="row mt-0 pt-0 success">
            <div class="col-12 sucess-message"><img class="mr-2" src="../../../assets/images/success-tick.png">
              Successfully Invited!</div>
          </div>

          <div class="row">
            <div class="col-12">
              <h1 class="mt-4">Host Details</h1>
            </div>
          </div>


          <div class="row mt-4">
            <div class="col-4">
              <p class="title">Full Name</p>
              <p class="result">{{data?.parkUser?.userName}}</p>
            </div>
            <div class="col-4">
              <p class="title">Mobile Number</p>
              <p class="result">{{data?.parkUser?.phoneNumber}}</p>
            </div>
            <div class="col-4">
              <p class="title">Email ID</p>
              <p class="result">{{data?.parkUser?.emailId}}</p>
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <h2 class="mt-3">Meeting Details</h2>
            </div>
          </div>


          <div class="row mt-4">
            <div class="col-2">
              <p class="title">Date</p>
              <p class="result">{{formatDate(data?.mstart, 'date')}}</p>
            </div>
            <div class="col-2">
              <p class="title">Time</p>
              <p class="result">{{formatDate(data?.mstart, 'time')}}</p>
            </div>
            <div class="col-3">
              <p class="title">Building Name</p>
              <p class="result">{{data?.buildingName}}</p>
            </div>
            <div class="col-3">
              <p class="title">Floor</p>
              <p class="result">{{data?.floor}}</p>
            </div>
            <div class="col-2"></div>
          </div>

          <div class="guest  mt-5" *ngFor="let item of data?.t0600Vmsguests;let i=index">

            <div class="row">
              <div class="col-12">
                <h1>Guest {{i+1}}</h1>
              </div>
            </div>

            <div class="row mt-4">
              <div class="col-4">
                <p class="title">Full Name</p>
                <p class="result">{{item?.fullName}}</p>
              </div>
              <div class="col-4">
                <p class="title">Mobile Number</p>
                <p class="result">{{item?.mobile}}</p>
              </div>
              <div class="col-4">
                <p class="title">Email ID</p>
                <p class="result">{{item?.email}}</p>
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-12">
                <p class="title">Visitor Company Name</p>
                <p class="result">{{item?.companyName}}</p>
              </div>
            </div>
            <!-- <h3 class="mt-4">Vehicle Details</h3>
            <div class="row mt-4">
              <div class="col-3">
                <p class="title">Vehicle Type</p>
                <p class="result">2 Wheeler</p>
              </div>
              <div class="col-3">
                <p class="title">Vehicle Number</p>
                <p class="result">{{item?.t0600GuestVehicles[0]?.vehicleNo}}</p>
              </div>
            </div> -->
          </div>

        </div>

        <div class="footer-layout">
          <button class="button-cancel" (click)="cancelInvite()">Cancel Invite</button>
          <button class="button-resend" (click)="resendInvite()">Resend Invite</button>
        </div>

        <!-- <app-footer></app-footer> -->

      </div>
    </div>
